import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import {
  HorizontalCard,
  CardHeader,
  CardTitle,
  FieldsGrid,
  FieldContainer,
  FieldLabel,
  FieldValue,
} from "../styles/DetallesPacienteStyles";
import { DataFormatters } from "../utils/CrearValidacionHojaQXConstants";

const PatientInfoCard = ({ pacienteIngresado }) => {
  if (!pacienteIngresado) return null;

  return (
    <Section testid="estatus-coberturas-section" width="100%">
      <HorizontalCard
        style={{ marginTop: "15px" }}
        testid="estatus-coberturas-card"
      >
        <CardHeader testid="estatus-coberturas-header">
          <CardTitle testid="estatus-coberturas-title">
            Información del paciente ingresado
          </CardTitle>
        </CardHeader>
        <FieldsGrid testid="estatus-coberturas-fields">
          <FieldContainer testid="field-numero-asegurado">
            <FieldLabel testid="label-numero-asegurado">
              Número de Asegurado
            </FieldLabel>
            <FieldValue testid="value-numero-asegurado">
              {pacienteIngresado?.numeroPlastico || "N/A"}
            </FieldValue>
          </FieldContainer>
          <FieldContainer testid="field-numero-ingreso">
            <FieldLabel testid="label-numero-ingreso">
              Número de ingreso
            </FieldLabel>
            <FieldValue testid="value-numero-ingreso">
              {pacienteIngresado?.numeroIngreso || "N/A"}
            </FieldValue>
          </FieldContainer>
          <FieldContainer testid="field-paciente">
            <FieldLabel testid="label-paciente">Paciente</FieldLabel>
            <FieldValue testid="value-paciente">
              {pacienteIngresado?.nombreDelPaciente || "N/A"}
            </FieldValue>
          </FieldContainer>
          <FieldContainer testid="field-fecha-ingreso">
            <FieldLabel testid="label-fecha-ingreso">
              Fecha de ingreso
            </FieldLabel>
            <FieldValue testid="value-fecha-ingreso">
              {DataFormatters.formatDate(pacienteIngresado?.fechaIngreso)}
            </FieldValue>
          </FieldContainer>
          <FieldContainer testid="field-fecha-egreso">
            <FieldLabel testid="label-fecha-egreso">Fecha de egreso</FieldLabel>
            <FieldValue testid="value-fecha-egreso">
              {DataFormatters.formatDate(pacienteIngresado?.fechaSalida)}
            </FieldValue>
          </FieldContainer>
        </FieldsGrid>
      </HorizontalCard>
    </Section>
  );
};

export default PatientInfoCard;
